// extracted by mini-css-extract-plugin
export default {"button":"edit-menu_button__zwyUm","modal":"edit-menu_modal__n2q6d","menuItem":"edit-menu_menuItem__mNaon","reportButton":"edit-menu_reportButton__JTAai"};